export enum DocumentsRequest {
  VisitSummary = 1,
  WellnessAndPreventativeCareSummary = 24,
  RabiesCertificate = 3,
  Prescription = 5,
  LabResult = 4,
  DischargeInstructions = 16,
  AnesthesiaMonitoring = 23,
  Invoice = 13,
  VisitConsent = 7,
  TreatmentConsent = 21,
  ClientConsent = 18,
  DentalExtractionsConsent = 19,
  SurgeryConsent = 22,
  EuthanasiaConsent = 20,
  VetSpireMedicalHistory = 28,
}

export const DocumentsRequestLabels: { [key: number]: string } = {
  1: 'Visit Summary',
  3: 'Rabies Certificate',
  4: 'Lab Result',
  5: 'Prescription',
  7: 'Visit Consent',
  16: 'Discharge Instructions',
  18: 'Client Consent',
  19: 'Dental Extractions Consent',
  20: 'Euthanasia Consent',
  21: 'Treatment Consent',
  22: 'Surgery Consent',
  23: 'Anesthesia Monitoring',
  24: 'Wellness And Preventative Care Summary',
  13: 'Invoice',
  28: 'Vetspire Medical History',
};

export enum DocumentsRequestCategory {
  Documents = 1,
  DocumentsImported = 2,
}

export const DocumentsRequestCategoryAssociation: {
  [key: number]: DocumentsRequestCategory;
} = {
  1: DocumentsRequestCategory.Documents,
  3: DocumentsRequestCategory.Documents,
  4: DocumentsRequestCategory.Documents,
  5: DocumentsRequestCategory.Documents,
  7: DocumentsRequestCategory.Documents,
  16: DocumentsRequestCategory.Documents,
  18: DocumentsRequestCategory.Documents,
  19: DocumentsRequestCategory.Documents,
  20: DocumentsRequestCategory.Documents,
  21: DocumentsRequestCategory.Documents,
  22: DocumentsRequestCategory.Documents,
  23: DocumentsRequestCategory.Documents,
  24: DocumentsRequestCategory.Documents,
  13: DocumentsRequestCategory.Documents,
  28: DocumentsRequestCategory.DocumentsImported,
};
